import { GraphQLClient } from "graphql-request";
import { getIdentificationData } from "./identification.utils";
import { VITE_GRAPHQL_URL } from "@/env";

export const graphqlClient = new GraphQLClient(VITE_GRAPHQL_URL, {
  headers: () => {
    const { token } = getIdentificationData();

    return {
      Authorization: token ?? "",
    };
  },
});
